exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2QM7Fx6GDcSk9mkS5K0lpe{padding:2.14286rem 2.14286rem 1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BottomButtons": "_2QM7Fx6GDcSk9mkS5K0lpe"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/BottomButtons/style.postcss
// module id = 1763
// module chunks = 0